export default __webpack_public_path__ + "static/media/dance-background.18ddbbc8.jpg";